export const themes = {
  default: {
    thButton:
      'mt-10 text-14 text-black hocus:text-black-active transition-color duration-250 ease-in underline',
  },
};
